//import { vuexfireMutations, firestoreAction } from "vuexfire";

import router from "@/router";


const state = {
    currentSlideDeck: null,
    currentSlide: null,
    selectedComponent: null,
    inlineEditor: null
    
};

const actions = {
  attachInlineEditor({state, commit}, payload) {
    commit("setInlineEditor", payload);
  },
  selectSlideDeck({ state, commit }, payload) {
    commit("setCurrentSlideDeck", payload);
  },
  selectSlide({ state, commit }, payload) {
    commit("setCurrentSlide", payload);
  },
  selectComponent({ state, commit }, payload) {
    commit("setSelectedComponent", payload);
  },
};

const mutations = {  
  setCurrentSlideDeck(state, payload) {
    state.currentSlideDeck = payload;
  },
  setCurrentSlide(state, payload) {
    state.currentSlide = payload;
  },
  setSelectedComponent(state, payload) {
    state.selectedComponent = (payload === state.selectedComponent) ? null : payload;
  },
  setInlineEditor(state, payload=null) {
    state.inlineEditor = payload;
  },  

};

const getters =  {
 
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
